import { render } from "./gamePage.vue?vue&type=template&id=1fedf6ac"
import script from "./gamePage.vue?vue&type=script&lang=js"
export * from "./gamePage.vue?vue&type=script&lang=js"

import "./gamePage.vue?vue&type=style&index=0&id=1fedf6ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__